export enum HookSize {
  FULL = 'FULL',
  HALF = 'HALF',
  THIRD = 'THIRD',
}